<template>
  <div class="footer">
    <ul class="map">
      <li>
        <a>网站地图</a>
      </li>
      <li>
        <router-link to="/recruit" class="linkhtml">人才招聘</router-link>
      </li>
      <li>
        <router-link to="/contact-us" class="linkhtml">联系我们</router-link>
      </li>
    </ul>
    <ul class="tel">
      <li>业务咨询：028-83396225</li>
      <li>公司总机：028-83396225</li>
      <li>投诉咨询热线：028-83396225</li>
    </ul>
    <div class="position">地址：成都市高新区锦尚西一路107号楚峰国际1202A</div>
    <div class="number">
      <a href="https://beian.miit.gov.cn" target="_blank">
        蜀ICP备20024932号-1
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    copyToClipboard() {
      let txt = window.location.href;
      if (window.clipboardData) {
        window.clipboardData.clearData();
        window.clipboardData.setData("Text", txt);
        this.$toast.center("链接已经复制到剪切板，请 CTRL+V 粘贴到其他地方吧");
      } else if (navigator.userAgent.indexOf("Opera") != -1) {
        window.location = txt;
      } else if (window.netscape) {
        try {
          netscape.security.PrivilegeManager.enablePrivilege(
            "UniversalXPConnect"
          );
        } catch (e) {
          this.$toast.center(
            "被浏览器拒绝！\n请在浏览器地址栏输入'about:config'并回车\n然后将'signed.applets.codebase_principal_support'设置为'true'"
          );
        }
        var clip = Components.classes[
          "@mozilla.org/widget/clipboard;1"
        ].createInstance(Components.interfaces.nsIClipboard);
        if (!clip) return;
        var trans = Components.classes[
          "@mozilla.org/widget/transferable;1"
        ].createInstance(Components.interfaces.nsITransferable);
        if (!trans) return;
        trans.addDataFlavor("text/unicode");
        var str = new Object();
        var len = new Object();
        var str = Components.classes[
          "@mozilla.org/supports-string;1"
        ].createInstance(Components.interfaces.nsISupportsString);
        var copytext = txt;
        str.data = copytext;
        trans.setTransferData("text/unicode", str, copytext.length * 2);
        var clipid = Components.interfaces.nsIClipboard;
        if (!clip) return false;
        clip.setData(trans, null, clipid.kGlobalClipboard);
        this.$toast.center("链接已经复制到剪切板，请 CTRL+V 粘贴到其他地方吧");
      } else {
        this.$toast.center(`谷歌浏览器不支持此功能，请直接手动复制<br /> ${txt}`);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.lx-toast {
  height: auto;
}
@media (min-width: 997px) {
  .footer {
    padding: 35px 0;
  }
  .tel {
    position: relative;
    width: 1000px;
    margin: 0 auto;
    margin-top: 20px;
    li {
      display: inline;
    }
    li + li {
      margin-left: 35px;
    }
  }
  .position {
    margin: 9px auto 40px auto;
  }
}
@media (max-width: 997px) {
  .footer {
    padding: 20px 0;
  }
  .map,
  .tel {
    margin-top: 10px;
    li {
      font-size: 12px;
      a {
        font-size: 12px;
      }
    }
  }
  .tel {
    li {
      display: block;
      text-align: center;
    }
  }
  .position {
    font-size: 12px;
    margin: 9px auto 20px auto;
  }
}
.footer {
  background-color: #333333;
  color: #fff;
  font-size: 14px;
  text-align: center;
  position: relative;
}
.map {
  text-align: center;
  li {
    display: inline;
    padding: 0 10px;
    border-right: 1px solid #fff;
    margin-top: 2px;
  }
  li:last-child {
    border: 0;
  }
}
.tel {
  text-align: center;
}
.position {
  text-align: center;
  width: 80%;
}
.number {
  font-size: 12px;
  margin: 5px 0;
  text-align: center;
}
</style>
